
<p>
  Google pay Test
</p>
<div id="buy-now">

</div>
